module.exports = __webpack_public_path__ + "static/media/iris_iot_logo.bcce900e.png";